import $ from "jquery";

window.$ = window.jQuery = $;
import './vendor/bootstrap/bootstrap-imports';
import './dynamic-bootstrap-components';


function Site(options) {

    this.init();
}

Site.defaults = {};

Site.prototype = {
    init: function () {
        Site.user._init();
    }
};

window.Site = Site;


/**
 * Donnée utilisateur utile
 */

(function ($, Site) {

    const user = {
        data: {
            id: null,
            name: null,
            latitude: null,
            longitude: null
        },

        geolocation: {
            update: function () {
                /* Sauvegarde dans le navigateur */
                user.saveStorage();
                /* Sauvegarde BDD */
                $.ajax('/ajax/user/save_geolocation.php', {
                    method: 'POST',
                    dataType: 'JSON',
                    data: {
                        latitude: user.data.latitude,
                        longitude: user.data.longitude,
                    },
                    success: function (data) {

                    }
                });

                user.geolocation.callbackUpdate.run();

            },
            callbackUpdate: (function () {
                var callbacks = [],
                    running = false,
                    isLauch = false;

                // fired on resize event
                function lauchCallback() {

                    if (!running) {
                        running = true;
                        runCallbacks();
                    }
                    isLauch = true;

                }

                // run the actual callbacks
                function runCallbacks() {

                    callbacks.forEach(function (callback) {
                        callback();
                    });

                    running = false;
                }

                // adds callback to loop
                function addCallback(callback) {

                    if (callback) {
                        callbacks.push(callback);
                    }

                }

                return {
                    // déclenche le callback
                    run: function () {
                        lauchCallback();
                    },
                    // public method to add additional callback
                    add: function (callback) {

                        addCallback(callback);
                        if (isLauch) {
                            callback();
                        }
                    }
                }
            })(),
            set: function () {
                var self = this;
                if (!user.getStorage()) {
                    $.ajax('/ajax/user/get_geolocation.php', {
                        dataType: 'JSON',
                        success: function (data) {
                            user.data.latitude = data.geolocation.latitude;
                            user.data.longitude = data.geolocation.longitude;
                            if (user.data.latitude === null && user.data.longitude === null) {
                                Site.helper.getLocationBrowser(function (dataGeolocBrowser) {
                                    user.data.latitude = dataGeolocBrowser.latitude;
                                    user.data.longitude = dataGeolocBrowser.longitude;
                                    user.geolocation.update();
                                    user.geolocation.callbackUpdate.run();
                                })
                            } else {
                                user.saveStorage();
                                user.geolocation.callbackUpdate.run();
                            }

                        }
                    });
                }
            }
        },

        _init: function () {
            this.setData();
        },

        getStorage: function () {
            if (localStorage.getItem('user') !== null) {
                user.data = JSON.parse(localStorage.getItem('user'));
                return true;
            }
            return false;
        },

        saveStorage: function () {
            localStorage.setItem('user', JSON.stringify(user.data));
        },

        setData: function () {
            var self = this;
            this.getStorage();

            /* Si on a pas les données de localisation */
            if (user.data.latitude === null && user.data.longitude === null) {
                self.geolocation.set();
            }

        }

    };

    Site.user = user;

})(jQuery, Site);


(function ($, Site) {

    const helper = {
        /**
         * Permet de demander au client l'autorisation de geolocaliser
         * @param callback
         * @returns {*}
         */
        getLocationBrowser: function (callback) {
            var geoloc = {
                latitude: null,
                longitude: null
            };
            callback(geoloc);
            // if (navigator.geolocation) {
            //     // L'API est disponible
            //     navigator.geolocation.getCurrentPosition(function (position) {
            //         geoloc.latitude = position.coords.latitude;
            //         geoloc.longitude = position.coords.longitude;
            //         callback(geoloc);
            //         return true;
            //     }, function () {
            //         callback(geoloc);
            //         return false;
            //     });
            //
            // } else {
            //     // Pas de support, proposer une alternative ?
            //     callback(geoloc);
            //     return false;
            // }
        },

        /**
         * Gestionnaire pour l'évenement resize
         */
        resize: (function () {

            var callbacks = [],
                running = false;

            // fired on resize event
            function resize() {

                if (!running) {
                    running = true;

                    if (window.requestAnimationFrame) {
                        window.requestAnimationFrame(runCallbacks);
                    } else {
                        setTimeout(runCallbacks, 66);
                    }
                }

            }

            // run the actual callbacks
            function runCallbacks() {

                callbacks.forEach(function (callback) {
                    callback();
                });

                running = false;
            }

            // adds callback to loop
            function addCallback(callback) {

                if (callback) {
                    callbacks.push(callback);
                }

            }

            return {
                // public method to add additional callback
                add: function (callback) {
                    if (!callbacks.length) {
                        window.addEventListener('resize', resize);
                    }
                    addCallback(callback);
                }
            }
        }())

    };

    Site.helper = helper;


})(jQuery, Site);

/* START ! */
var jsSite = new Site();


import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';

import SwiperAnimation from '@cycjimmy/swiper-animation';


const reponsive = {
    xs: '767',
    sm: '991',
    md: '1263'
};

const swiperAnimation = new SwiperAnimation();
const swiper = new Swiper('.swiper-home', {
    modules: [Navigation, Pagination],
    on: {
        init: function () {
            swiperAnimation.init(this).animate();
        },
        slideChange: function () {
            swiperAnimation.init(this).animate();
        }
    }
});

const settingsSwiperBrands = {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 2,
    spaceBetween: 30,
    loop: true,
    loopAddBlankSlides: true,
    breakpoints: {},
    autoplay: {
        delay: 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
};

settingsSwiperBrands['breakpoints'][reponsive.xs] = {
    slidesPerView: 2,
    slidesPerGroup: 1
};
settingsSwiperBrands['breakpoints'][reponsive.sm] = {
    slidesPerView: 3,
    slidesPerGroup: 1
};
settingsSwiperBrands['breakpoints'][reponsive.md] = {
    slidesPerView: 7,
    slidesPerGroup: 1
};

const swiperBrands = new Swiper('.swiper-brands', settingsSwiperBrands);


const settingsSwiperOffres = {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {},
    navigation: {
        nextEl: '.offres .swiper-button-next',
        prevEl: '.offres .swiper-button-prev',
    },
};

settingsSwiperOffres['breakpoints'][reponsive.xs] = {
    slidesPerView: 1,
    slidesPerGroup: 1
};
settingsSwiperOffres['breakpoints'][reponsive.sm] = {
    slidesPerView: 1,
    slidesPerGroup: 1
};
settingsSwiperOffres['breakpoints'][reponsive.md] = {
    slidesPerView: 2,
    slidesPerGroup: 1
};


const swiperOffres = new Swiper('.swiper-offres', settingsSwiperOffres);



const settingsSwiperOrganization = {
    modules: [Navigation, Pagination],
    breakpoints: {},
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
};



const swiperOrganization = new Swiper('.swiper-organisation', settingsSwiperOrganization);



